import { Drawer } from '@mui/material';
import CloseIcon from '@material-ui/icons/Close';
import './styles.scss';

export interface SydDrawerProps {
  isOpen: boolean
  children: React.ReactNode
  title: string
  handleClose: () => void
}

const SydDrawer = (props: SydDrawerProps) => {
  const { isOpen, children, title, handleClose } = props;

  return(
    <Drawer
      anchor="right"
      open={isOpen}
      SlideProps={{ mountOnEnter: true, unmountOnExit: true }}
      onClose={handleClose}
      className="syd-drawer"
    >
      <div className="syd-drawer-content">
        <div className='syd-drawer-content-header'>
          <span>{title}</span>
          <div className='close-icon' onClick={handleClose}>
            <CloseIcon />
          </div>
        </div>
        {children}
      </div>
    </Drawer>
  )
}

export default SydDrawer;